import { createContext, useContext, useEffect, useState, useCallback } from "react"
import { onAuthStateChanged } from "firebase/auth"
import { doc, getDoc } from "firebase/firestore"
import { auth, db } from "../services/firebase"

const AuthContext = createContext()

export function AuthProvider({ children }) {
  const [user,        setUser]        = useState(null)
  const [userData,    setUserData]    = useState(null)   // usuarios_web
  const [clienteData, setClienteData] = useState(null)   // usuarios_sheets (puntos, etc.)
  const [loading,     setLoading]     = useState(true)

  async function fetchUserData(firebaseUser) {
    // 1. Leer usuarios_web (auth, rol, id_cliente_asociado)
    const refWeb  = doc(db, "usuarios_web", firebaseUser.uid)
    const snapWeb = await getDoc(refWeb)

    if (!snapWeb.exists()) {
      setUserData(null)
      setClienteData(null)
      return
    }

    const data = snapWeb.data()
    setUserData(data)

    // 2. Si tiene id_cliente_asociado → leer usuarios_sheets (puntos, perfil)
    if (data.id_cliente_asociado) {
      const id = data.id_cliente_asociado.toString()
      const refSheets  = doc(db, "usuarios_sheets", id)
      const snapSheets = await getDoc(refSheets)
      setClienteData(snapSheets.exists() ? snapSheets.data() : null)
    } else {
      setClienteData(null)
    }
  }

  const refreshUserData = useCallback(async () => {
    if (user) await fetchUserData(user)
  }, [user])

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser)
        await fetchUserData(firebaseUser)
      } else {
        setUser(null)
        setUserData(null)
        setClienteData(null)
      }
      setLoading(false)
    })
    return () => unsub()
  }, [])

  return (
    <AuthContext.Provider value={{ user, userData, clienteData, loading, refreshUserData }}>
      {!loading && children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}